'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:train:gotoOrderList');
}

var _invoke = require('../invoke');

/**
 *
 * @memberof train
 * @static
 * @name gotoOrderList
 * @param {String} url 订单列表地址
 * @return {Undefined}
 * @example
 *  hbnb.train.gotoOrderList('url');
 */
module.exports = function(url) {
    if (process.env.NODE_ENV !== 'production') {
        debug('url is %s', url);
    }

    _invoke('train', 'goto_order_list', {
        url: url
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/train/goto-order-list.js
// module id = 629
// module chunks = 0